// @ts-nocheck

(() => {
  "use strict";

  const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

  const bindRoot = (root) => {
    const typeInputs = [
      ...root.querySelectorAll("[data-personalization-type]"),
    ];
    const attachmentInput = root.querySelector(
      "[data-attachment-input]"
    );

    if (!typeInputs.length || !attachmentInput) return null;

    // El contenedor de checkout acelerado ("Comprar ahora") vive fuera de
    // .el-personalizer, como hermano dentro del mismo product-form.
    const formScope =
      root.closest("product-form-component") ||
      root.closest("form") ||
      document;
    const acceleratedCheckoutContainer = formScope.querySelector(
      '[ref="acceleratedCheckoutButtonContainer"]'
    );
    const form = root.closest("form");

    const textField = root.querySelector(
      "[data-engraving-text-input]"
    );
    const attachmentField = root.querySelector(
      "[data-attachment-field]"
    );
    const attachmentTrigger = root.querySelector(
      "[data-attachment-trigger]"
    );
    const attachmentRequiredMark = root.querySelector(
      "[data-attachment-required]"
    );
    const preview = root.querySelector(
      "[data-attachment-preview]"
    );
    const thumbnail = root.querySelector(
      "[data-attachment-thumbnail]"
    );
    const filenameEl = root.querySelector(
      "[data-attachment-filename]"
    );
    const changeButton = root.querySelector(
      "[data-attachment-change]"
    );
    const removeButton = root.querySelector(
      "[data-attachment-remove]"
    );
    const errorEl = root.querySelector(
      "[data-attachment-error]"
    );
    const statusBadge = root.querySelector(
      "[data-engraving-status]"
    );

    let objectUrl = null;

    const revokeObjectUrl = () => {
      if (!objectUrl) return;
      URL.revokeObjectURL(objectUrl);
      objectUrl = null;
    };

    const showError = (message) => {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    };

    const clearError = () => {
      if (!errorEl) return;
      errorEl.textContent = "";
      errorEl.hidden = true;
    };

    const getSelectedType = () => {
      const checked = typeInputs.find(
        (input) => input.checked
      );
      return checked ? checked.value : "Texto";
    };

    const hasValidFile = () =>
      Boolean(
        attachmentInput.files &&
          attachmentInput.files.length > 0
      );

    const hasValidText = () =>
      Boolean(textField && textField.value.trim());

    // Riesgo 2: "Diseño listo" debe reflejar los tres tipos de
    // personalización, no solo el texto — required sigue siendo la
    // validación real; esto es puramente informativo.
    const updateStatus = () => {
      if (!statusBadge) return;

      const type = getSelectedType();
      let ready = false;

      if (type === "Imagen") {
        ready = hasValidFile();
      } else if (type === "Texto e imagen") {
        ready = hasValidText() && hasValidFile();
      } else {
        ready = hasValidText();
      }

      statusBadge.hidden = !ready;
    };

    const resetAttachment = () => {
      revokeObjectUrl();
      attachmentInput.value = "";

      if (preview) preview.hidden = true;
      if (thumbnail) thumbnail.removeAttribute("src");
      if (filenameEl) filenameEl.textContent = "";
      if (attachmentTrigger) attachmentTrigger.hidden = false;

      clearError();
      updateStatus();
    };

    const applyType = () => {
      const type = getSelectedType();

      const needsText = type !== "Imagen";
      const needsFile = type !== "Texto";

      if (textField) {
        textField.required = needsText;
        textField.setAttribute(
          "aria-required",
          String(needsText)
        );
      }

      attachmentInput.required = needsFile;
      attachmentInput.setAttribute(
        "aria-required",
        String(needsFile)
      );

      if (attachmentRequiredMark) {
        attachmentRequiredMark.hidden = !needsFile;
      }

      if (attachmentField) {
        attachmentField.hidden = type === "Texto";
      }

      // Checkout acelerado ("Comprar ahora") serializa los campos del
      // formulario para construir el pedido sin pasar por nuestro fetch a
      // /cart/add.js. Con un <input type="file">, eso lee el .value del
      // campo — que por seguridad del navegador es siempre el texto falso
      // "C:\fakepath\nombre.ext", nunca el archivo real. No hay forma de
      // arreglar esto desde el theme (payment_button es un componente
      // cerrado de Shopify), así que en los modos con imagen se oculta
      // "Comprar ahora" y se obliga a pasar por "Agregar al carrito", que
      // sí envía el archivo real vía FormData(form).
      if (acceleratedCheckoutContainer) {
        if (needsFile) {
          if (!acceleratedCheckoutContainer.hidden) {
            acceleratedCheckoutContainer.hidden = true;
            acceleratedCheckoutContainer.dataset.hiddenByPersonalizer =
              "true";
          }
        } else if (
          acceleratedCheckoutContainer.dataset
            .hiddenByPersonalizer === "true"
        ) {
          // Solo revertimos el ocultamiento que nosotros mismos aplicamos;
          // si está oculto por otra razón (p. ej. variante agotada), esa
          // lógica en product-form.js sigue teniendo la última palabra.
          acceleratedCheckoutContainer.hidden = false;
          delete acceleratedCheckoutContainer.dataset
            .hiddenByPersonalizer;
        }
      }

      if (!needsFile && attachmentInput.value) {
        resetAttachment();
        return;
      }

      updateStatus();
    };

    typeInputs.forEach((input) => {
      input.addEventListener("change", applyType);
    });

    if (textField) {
      textField.addEventListener("input", updateStatus);
      textField.addEventListener("change", updateStatus);
    }

    if (attachmentTrigger) {
      attachmentTrigger.addEventListener("click", () => {
        attachmentInput.click();
      });
    }

    if (changeButton) {
      changeButton.addEventListener("click", () => {
        attachmentInput.click();
      });
    }

    if (removeButton) {
      removeButton.addEventListener("click", () => {
        resetAttachment();
      });
    }

    attachmentInput.addEventListener("change", () => {
      const file =
        attachmentInput.files && attachmentInput.files[0];

      if (!file) {
        resetAttachment();
        return;
      }

      if (
        !file.type ||
        !file.type.startsWith("image/")
      ) {
        showError(
          "Ese archivo no es una imagen. Elegí una foto, firma o dibujo en formato de imagen."
        );
        resetAttachment();
        return;
      }

      if (file.size > MAX_FILE_SIZE_BYTES) {
        showError(
          "La imagen pesa demasiado. Elegí un archivo de hasta 10 MB."
        );
        resetAttachment();
        return;
      }

      clearError();
      revokeObjectUrl();
      objectUrl = URL.createObjectURL(file);

      if (thumbnail) thumbnail.src = objectUrl;
      if (filenameEl) filenameEl.textContent = file.name;
      if (preview) preview.hidden = false;
      if (attachmentTrigger) attachmentTrigger.hidden = true;

      updateStatus();
    });

    // Instrumentación temporal (no bloqueante): confirma en consola, justo
    // antes de que Horizon procese el submit real, que lo que viaja en
    // properties[Imagen de referencia] es el archivo real y no el texto
    // "C:\fakepath\..." que un input file devuelve por .value. No llama
    // preventDefault ni altera el envío.
    if (form) {
      form.addEventListener("submit", () => {
        if (getSelectedType() === "Texto") return;

        const file =
          attachmentInput.files && attachmentInput.files[0];

        if (!file) {
          console.warn(
            "[EspacioLaser] Se envía el formulario sin archivo en properties[Imagen de referencia]."
          );
          return;
        }

        const isFile = file instanceof File;
        const hasSize = file.size > 0;
        const isImage = Boolean(
          file.type && file.type.startsWith("image/")
        );

        if (!isFile || !hasSize || !isImage) {
          console.error(
            "[EspacioLaser] properties[Imagen de referencia] inválida antes de enviar:",
            { isFile, hasSize, isImage, value: attachmentInput.value }
          );
        }
      });
    }

    applyType();

    return () => {
      applyType();
      updateStatus();
    };
  };

  const mountAll = () => {
    document
      .querySelectorAll(".el-personalizer")
      .forEach((root) => {
        if (typeof root.__attachmentResync === "function") {
          // La raíz ya estaba enlazada (montaje inicial o re-render
          // previo): solo se vuelve a sincronizar el estado
          // requerido/oculto/"Diseño listo", sin duplicar listeners.
          root.__attachmentResync();
          return;
        }

        const resync = bindRoot(root);
        if (resync) {
          root.__attachmentResync = resync;
        }
      });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      mountAll,
      { once: true }
    );
  } else {
    mountAll();
  }

  // Reutiliza el evento agregado en el Sprint 1 de estabilidad del
  // Personalizador V2 (assets/product-form.js) para resincronizar
  // este selector después de un cambio de variante.
  document.addEventListener(
    "engraving:v2:variant-settled",
    mountAll
  );
})();
